"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalClassNames = exports.schemes = void 0;
exports.schemes = ['neo4j', 'neo4j+s', 'neo4j+scc', 'bolt', 'bolt+s', 'bolt+scc'];
exports.globalClassNames = {
    semantic: {
        login: 'login ui middle aligned center aligned grid',
        loginContainer: 'column',
        loginServerGroup: 'fields',
        loginOtherDatabase: 'form-group ui aligned',
        form: 'ui form',
        formError: 'ui negative message',
        formGroup: 'form-group field',
        formInput: 'form-control',
        formButtons: 'form-buttons',
        formButtonPrimary: 'ui button primary',
        formButtonSecondary: 'ui button basic primary',
    },
};
